import type { HttpErrorResponse } from '@angular/common/http';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import {
  IGroupEnrollment,
  type IGroupEnrollmentUpdate,
} from 'src/app/shared/interfaces/group-enrollment/group-enrollment.interface';
import { AlertService } from 'src/app/shared/services/alert.service';
import { GroupEnrollmentService } from 'src/app/shared/services/group-enrollment/insurance/group-enrollment.service';

@Component({
  selector: 'app-edit-group-enrollment-note-modal',
  templateUrl: './edit-group-enrollment-note-modal.component.html',
})
export class EditGroupEnrollmentNoteModalComponent
  implements OnInit, OnDestroy
{
  @Input() groupEnrollment: IGroupEnrollment;

  noteFrom: UntypedFormGroup;
  groupEnrollmentID: string;

  isLoading: boolean;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private groupEnrollmentService: GroupEnrollmentService,
    private alertService: AlertService,
  ) {}

  ngOnInit() {
    this.groupEnrollmentID = this.groupEnrollment.id;

    this.noteFrom = this.fb.group({
      notes: [this.groupEnrollment.notes || '', [Validators.required]],
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  save() {
    const formValue: IGroupEnrollmentUpdate = {
      ...this.groupEnrollment,
      ...this.noteFrom.value,
    };

    this.isLoading = true;

    this.subscriptions.add(
      this.groupEnrollmentService.editGroupEnrollment(formValue).subscribe({
        next: () => {
          const successMessage = `Note for ${this.groupEnrollmentID} has been updated successfully!`;

          this.isLoading = false;
          this.alertService.success(successMessage);
          this.activeModal.close();
        },
        error: (error: HttpErrorResponse | string) => {
          this.isLoading = false;
          this.alertService.error(error);
        },
      }),
    );
  }

  close() {
    this.activeModal.dismiss();
  }
}
